module.exports = __webpack_public_path__ + "img/vysy_coin.eaf1d7c0.png";